export const NOTES = [
  "Withdrawal from Wallet",
  "Deposit to Cold Storage",
  "Creation of new vaults",
  "Withdrawal from Cold Storage",
  "Starting or accepting escrows",
];
